import React from 'react';
import NotesView from './components/NotesView';
import { NotesControllerProps, useNotesController } from './hooks/useNotesController';

const Notes: React.FC<NotesControllerProps> = (props) => {
    const ctrl = useNotesController(props);
    return <NotesView {...ctrl} />;
};

export default Notes;
